<template>
    <div>
        <vuestic-widget :header-text="'Listar Compras'">
            <div style="font-weight: bold" class="sumary">
                Mostrando
                <b> {{$data.datosOrdenes.length}}</b>
                de
                <b> {{$data.datosOrdenes.length}}</b>
            </div>
            <br>
            <table class="table table-bordered table-responsive table-striped">
                <thead class="thead-dark">
                <tr>
                    <th scope="col" v-for="column in columns">{{column}}</th>
                </tr>
                </thead>
                <tbody >
                <tr>
                    <td><input type="text" class="form-control-sm"
                    placeholder="Buscar Por Folio" v-model="folio"></td>

                    <td><input type="text" class="form-control-sm"
                               placeholder="Buscar Por Proveedor" v-model="buscarProveedor"></td>

                    <td><input type="date" v-model="fecha" ></td>

                    <td><input type="date" v-model="fechaRecepcion"></td>
                    <td>
                        <select class="tipo" v-model="tipo">
                            <option value="">Selecione...</option>
                            <option value="0">Venta</option>
                            <option value="1">Encargo</option>
                            <option value="2">Stock</option>
                        </select>
                    </td>
                    <td><input type="text" v-model="condicion" class="form-control-sm"></td>

                    <td><input type="text" v-model="atencion" class="form-control-sm"></td>

                    <td><select v-model="estado">
                        <option value="">Selecione...</option>
                        <option value="0">Estado Emitida</option>
                        <option value="1">Estado Rechazada</option>
                        <option value="2">Estado Pendiente</option>
                        </select>
                    </td>

                    <td></td>
                </tr>
                <tr v-for="dato in datosOrdenes">
                    <td>{{dato.id}}</td>
                    <td>{{dato.proveedor.nombre}}</td>
                    <td>{{dato.fecha | fechaFormato}}</td>
                    <td>{{dato.fecha_recepcion | fechaFormato}}</td>
                    <td>{{dato.tipo | nombreTipo}}</td>
                    <td>{{dato.condicion_pago | capitalize}}</td>
                    <td>{{dato.atencion_a | capitalize}}</td>
                    <td>{{dato.estado | nombreEstado }}</td>
                    <td><i class="entypo entypo-eye" @click="showLargeModal()">
                        </i>
                        <i class="entypo entypo-pencil" @click="editar(dato)">
                        </i>
                        <i class="entypo entypo-erase">
                        </i>
                    </td>
                </tr>
                </tbody>
            </table>
        </vuestic-widget>
        <vuestic-modal :show.sync="show" v-bind:large="true" ref="largeModal">
            <table class="table">
                <thead>

                </thead>
            </table>
        </vuestic-modal>
    </div>

</template>

<script>
    import axios from 'axios'
    import InputComponent from "../../../input/InputComponent";
    import VuesticModal from "../../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal";
    import VuesticCard from "../../../../vuestic-theme/vuestic-components/vuestic-card/VuesticCard";
    import VuesticWidget from "../../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
    export default {
        name: "FilterOrdenCompra",
        components: {VuesticWidget, VuesticCard, VuesticModal, InputComponent},
        data(){
            return{
                borrar:'',
                show: true,
                datosOrdenes:[],
                folio:'',
                buscarProveedor:'',
                tipo:'',
                fecha:'',
                fechaRecepcion:'',
                condicion:'',
                atencion:'',
                estado:'',
                nuevaOrden:{},
                columns:['Folio', 'Proveedor', 'Fecha',
                    'Fecha Recepcion','Tipo', 'Condición Pago',
                    'Atencion A', 'Estado', 'Acciones']
            }
        },
        created(){
            this.llenarOrdenCompra()
        },
        computed:{
            filtrarPor: function () {
                return this.datosOrdenes.filter((orden) => {
                     return `${orden.id}`.match(this.folio) &&
                             orden.proveedor.nombre.toLowerCase().match(this.buscarProveedor.toLowerCase()) &&
                             orden.fecha.match(this.fecha) &&
                             orden.fecha_recepcion.match(this.fechaRecepcion) &&
                             `${orden.tipo}`.match(this.tipo) &&
                             orden.condicion_pago.match(this.condicion)&&
                             orden.atencion_a.toLowerCase().match(this.atencion.toLowerCase()) &&
                             `${orden.estado}`.match(this.estado)
                })
            },
        },
        methods: {
            editar(){
                alert('test')
            },
            llenarOrdenCompra() {
                const self = this;
                axios.get('http://mirandav2.local/api/compras/orden-compra')
                    .then(function (resp) {
                        self.datosOrdenes = resp.data
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            },
            showLargeModal () {
                this.$refs.largeModal.open()
            },
        },
        filters: {
            nombreTipo: function (value) {
                if (value === 0) {
                    value = 'Venta'
                } else if (value === 1) {
                    value = 'Encargo'
                } else if (value === 2) {
                    value = 'Stock'
                }
                return value
            },
            fechaFormato: function (fecha) {
                return fecha.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')

            },
            capitalize: function (value) {
                if (!value) return ''
                value = value.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            },
            nombreEstado: function (value) {
                if (value === 0) {
                    value = 'Estado Emitida'
                } else if (value === 1) {
                    value = 'Estado Rechazado'
                } else if (value === 2) {
                    value = 'Estado Pendiente'
                }
                return value
            }
          }
        }
</script>

<style scoped>
    .form-control-sm{
        height: 30px;
        width: 9em;
        position: relative;
    }
    .entypo{
      cursor: pointer;
      margin-left: 5px;
    }
    select{
        width: 10em;
        height: 2em;
    }
    option{
        cursor: pointer;
    }
    table{
        height: 100%;
        width: 100%;
    }
</style>
